var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMinWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 140C108.66 140 140 108.66 140 70C140 31.3401 108.66 0 70 0C31.3401 0 0 31.3401 0 70C0 108.66 31.3401 140 70 140ZM122.951 70C122.951 99.2438 99.2438 122.951 70 122.951C40.7562 122.951 17.0495 99.2438 17.0495 70C17.0495 40.7562 40.7562 17.0495 70 17.0495C99.2438 17.0495 122.951 40.7562 122.951 70ZM69.0379 37.333C50.0843 37.333 37.332 47.989 37.332 70.6984C37.332 90.8749 47.726 102.666 64.9327 102.666C72.8811 102.666 79.3445 99.6093 82.5762 93.9319H84.8472L85.5459 101.793H98.2982V66.5059H64.9327V78.8214H81.2661C80.5673 85.4596 74.89 89.5647 67.7278 89.5647C59.168 89.5647 53.9274 83.8 53.9274 75.3277V65.3704C53.9274 56.5487 58.9934 51.046 68.2518 51.046C74.5406 51.046 78.9078 53.4917 79.9559 58.8196H96.3766C95.9399 45.8927 85.3713 37.333 69.0379 37.333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMinWhite);
export default __webpack_public_path__ + "static/media/logo_min_white.2461df6e1607a0a68164c3733ccf7ad1.svg";
export { ForwardRef as ReactComponent };